import DataStructure, { sanitize } from "./DataStructure.js";
import { uid } from "quasar";
import { deepFreeze, formatCurrency } from "../util/misc.js";
import { QUOTE_LABOR_TYPES } from "./QuoteLaborItem.js";

export const CUSTOMER_QUOTE_LABOR_ITEM_FIELDS = {
  id: "",
  itemType: "labor",
  line: 0,
  manHours: null,
  quantity: 0,
  category: "",
  description: "",
  type: "",
  price: null,
  notax: false,
};
deepFreeze(CUSTOMER_QUOTE_LABOR_ITEM_FIELDS);

export default class CustomerQuoteLaborItem extends DataStructure {
  constructor(data = {}) {
    data = sanitize(data, CUSTOMER_QUOTE_LABOR_ITEM_FIELDS);

    if (!data.id) {
      data.id = uid().slice(-12);
    }

    super(data);
  }

  // Editing

  get isValid() {
    return Boolean(
      this.type && this.data.price !== null && this.data.cost !== null
    );
  }

  // Formatting

  get price() {
    return this.data.price === null ? null : formatCurrency(this.data.price);
  }

  get total() {
    return formatCurrency(this.data.price === null ? 0 : this.data.price);
  }

  get type() {
    return QUOTE_LABOR_TYPES[this.data.type] || null;
  }

  summary(length = 200) {
    const description = this.data.description.replace(
      /^\*\*+[^*]+\*\*+\s*/gm,
      ""
    );
    return length === null
      ? description
      : description.slice(0, length) + (description.length > length ? "…" : "");
  }

  toString() {
    return this.summary();
  }
}
